import Vue from 'vue';

const ModalBus = new Vue();

export default ModalBus;
